import moment from 'moment';

export const getDatePickerToMomentProps: () => {
  getValueProps: (value: any) => {
    value: any;
  };
  normalize: (value: any) => any;
} = () => ({
  getValueProps: (value: any) => ({
    value: value && moment(value) // Convert the value to a Moment object
  }),
  normalize: (value: any) => value && moment(value).format() // Convert the Moment object back to a formatted string
});

export const getYearDropdownOptions = (
  yearRange: number = 25
): Array<{label: string; value: string}> => {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + yearRange;

  const options: Array<{label: string; value: string}> = [];
  for (let year = endYear; year >= currentYear; year -= 1) {
    options.push({label: String(year), value: String(year)});
  }

  return options;
};
